import { create } from 'zustand';
import { nanoid } from 'nanoid';

export type ToastTone = 'info' | 'success' | 'warning' | 'danger';

export interface Toast {
  id: string;
  tone: ToastTone;
  title: string;
  description?: string;
  durationMs?: number;
  action?: { label: string; onClick: () => void };
}

interface ToastStore {
  toasts: Toast[];
  push: (toast: Omit<Toast, 'id'>) => string;
  dismiss: (id: string) => void;
  clear: () => void;
}

export const useToastStore = create<ToastStore>((set, get) => ({
  toasts: [],
  push: (toast) => {
    const id = nanoid();
    const newToast: Toast = { id, durationMs: 5000, ...toast };
    set((s) => ({ toasts: [...s.toasts, newToast] }));
    if (newToast.durationMs && newToast.durationMs > 0) {
      setTimeout(() => get().dismiss(id), newToast.durationMs);
    }
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  clear: () => set({ toasts: [] }),
}));
